import i18n from 'i18next'
import { initReactI18next } from 'react-i18next'
import LanguageDetector from 'i18next-browser-languagedetector'
import de from './locales/de.json'
import en from './locales/en.json'

export const SUPPORTED_UI_LANGUAGES = ['de', 'en'] as const
export type UiLanguage = (typeof SUPPORTED_UI_LANGUAGES)[number]

export const DEFAULT_LANGUAGE: UiLanguage = 'de'

function normalizeLanguage(lng: string): UiLanguage {
  const base = lng.split('-')[0]
  return SUPPORTED_UI_LANGUAGES.includes(base as UiLanguage) ? (base as UiLanguage) : DEFAULT_LANGUAGE
}

export function getIntlLocale(language?: string): string {
  const lng = normalizeLanguage(language || i18n.language || DEFAULT_LANGUAGE)
  return lng === 'en' ? 'en-US' : 'de-DE'
}

export function syncDocumentLanguage(language: string) {
  if (typeof document !== 'undefined') {
    document.documentElement.lang = normalizeLanguage(language)
  }
}

export async function changeAppLanguage(code: UiLanguage) {
  await i18n.changeLanguage(code)
  syncDocumentLanguage(code)
}

void i18n
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    resources: {
      de: { translation: de },
      en: { translation: en },
    },
    fallbackLng: DEFAULT_LANGUAGE,
    supportedLngs: [...SUPPORTED_UI_LANGUAGES],
    interpolation: { escapeValue: false },
    detection: {
      order: ['localStorage', 'navigator'],
      caches: ['localStorage'],
      lookupLocalStorage: 'i18nextLng',
    },
  })
  .then(() => {
    syncDocumentLanguage(i18n.language)
  })

export default i18n
